import { connect } from 'react-redux';
import { suaTienLai, suaTienGoc, suaTienGop, nhapPhiPhat } from 'actions/DongLai';
import DongLai from 'components/CommonComponent/DongLai';
import {
  getLanDongLaiChoVay,
  getLaiDenNgayChoVay,
  getLaiDenKyChoVay,
} from 'actions/QuanLyChoVay';
import {
  postThanhToanChoVay,
  deleteThanhToanChoVay,
  updateObjThanhToan,
  postThanhToanAllChoVay,
} from 'actions/QuanLyThuChi';
import { showInPhieuThuChi } from 'actions/InThuChi';
import { getInLanDongLai } from 'actions/InLanDongLai';
import { getComboCHDT } from 'actions/CuaHangDoiTac';

const mapStateToProps = (state) => ({
  camdo: state.camdo,
  quanlychovay: state.quanlychovay,
  quanlythuchi: state.quanlythuchi,
  user: state.user,
  cauhinh: state.cauhinh,
  phanquyen: state.phanquyen,
  cuahangdoitac: state.cuahangdoitac,
});

const mapDispatchToProps = (dispatch) => ({
  suaTienLai: (dataPost, dataSearch) =>
    dispatch(suaTienLai(dataPost, dataSearch)),
  suaTienGoc: (dataPost, dataSearch) =>
    dispatch(suaTienGoc(dataPost, dataSearch)),
  suaTienGop: (dataPost, dataSearch) =>
    dispatch(suaTienGop(dataPost, dataSearch)),
  nhapPhiPhat: (dataPost, dataSearch) =>
    dispatch(nhapPhiPhat(dataPost, dataSearch)),
  getLanDongLaiChoVay: (dataSearch) =>
    dispatch(getLanDongLaiChoVay(dataSearch)),
  getLaiDenKyChoVay: (data) => dispatch(getLaiDenKyChoVay(data)),
  getLaiDenNgayChoVay: (data) => dispatch(getLaiDenNgayChoVay(data)),
  postThanhToanChoVay: (dataPost, dataSearch) =>
    dispatch(postThanhToanChoVay(dataPost, dataSearch)),
  deleteThanhToanChoVay: (dataPost, dataSearch) =>
    dispatch(deleteThanhToanChoVay(dataPost, dataSearch)),
  updateObjThanhToan: (dataPost) => dispatch(updateObjThanhToan(dataPost)),
  postThanhToanAllChoVay: (dataPost, dataSearch) =>
    dispatch(postThanhToanAllChoVay(dataPost, dataSearch)),
  showInPhieuThuChi: (thuChiId) => dispatch(showInPhieuThuChi(thuChiId)),
  getInLanDongLai: (dataSearch) => dispatch(getInLanDongLai(dataSearch)),
  getComboCHDT: (dataSearch) => dispatch(getComboCHDT(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DongLai);
